// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p-card {
  border: 1px solid var(--gc-border-color);
}

.card-title {
  padding: 1rem;
  border-bottom: 1px solid var(--gc-border-color);
}

.container {
  display: grid;
  gap: 2rem;
  grid-template-columns: [image-start] 150px [image-end data] 1fr [data-end];
  grid-auto-rows: min-content;
}
.container > *:not(.profile) {
  height: 100%;
  position: relative;
}
.container .profile {
  width: 150px;
  grid-column: image;
}
.container .data {
  --grid-layout-gap: 1rem;
  --grid-item-min-width: 200px;
  grid-column: data;
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--grid-item-min-width));
  grid-gap: var(--grid-layout-gap);
}

.card-item {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

@media screen and (max-width: 1200px) {
  .card-item {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media screen and (max-width: 992px) {
  .card-item {
    flex: 0 0 auto;
    width: 100%;
  }
}
.contract-list {
  gap: 1px;
}
.contract-list .contract {
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--gc-border-color);
}
.contract-list .contract:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/person/id/overview/overview.page.sass"],"names":[],"mappings":"AAEA;EACI,wCAAA;AADJ;;AAGA;EACI,aAAA;EACA,+CAAA;AAAJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,0EAAA;EACA,2BAAA;AACJ;AAAI;EACI,YAAA;EACA,kBAAA;AAER;AADI;EACI,YAlBK;EAmBL,kBAAA;AAGR;AAFI;EACI,uBAAA;EACA,4BAAA;EAEA,iBAAA;EACA,aAAA;EACA,oEAAA;EACA,gCAAA;AAGR;;AADA;EACQ,cAAA;EACA,qBAAA;AAIR;;AAHA;EACI;IACI,cAAA;IACA,UAAA;EAMN;AACF;AANA;EACI;IACI,cAAA;IACA,WAAA;EAQN;AACF;AAPA;EACI,QAAA;AASJ;AARI;EACI,iBAAA;EACA,+CAAA;AAUR;AATQ;EACI,mBAAA;AAWZ","sourcesContent":["$image_size: 150px\n\np-card\n    border: 1px solid var(--gc-border-color)\n\n.card-title\n    padding: 1rem\n    border-bottom: 1px solid var(--gc-border-color)\n\n.container\n    display: grid\n    gap: 2rem\n    grid-template-columns: [image-start] $image-size [image-end data] 1fr [data-end]\n    grid-auto-rows: min-content\n    > *:not(.profile)\n        height: 100%\n        position: relative\n    .profile\n        width: $image_size\n        grid-column: image\n    .data\n        --grid-layout-gap: 1rem\n        --grid-item-min-width: 200px\n        \n        grid-column: data\n        display: grid\n        grid-template-columns: repeat(auto-fill, var(--grid-item-min-width))\n        grid-gap: var(--grid-layout-gap)\n\n.card-item\n        flex: 0 0 auto\n        width: calc(100% / 3)\n@media screen and (max-width: 1200px) \n    .card-item\n        flex: 0 0 auto\n        width: 50%\n@media screen and (max-width: 992px) \n    .card-item\n        flex: 0 0 auto\n        width: 100%\n\n.contract-list\n    gap: 1px\n    .contract\n        padding: 0.5rem 0\n        border-bottom: 1px solid var(--gc-border-color)\n        &:last-child\n            border-bottom: none"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
